import { SiteIdOverrideConfig } from "stores/wizard/config";
import { timeValues24HoursFormat } from "src/components/shared/TimeDropdown/config/time/timeValues";

export const siteId70961: SiteIdOverrideConfig = {
  package: {
    showAllSubLOB: false,
    lobLabels: {
      hotelsLabel: "wizard.properties.tab.title.label",
    },
  },
  car: {
    location: {
      destination: {
        inputName: "returnName",
      },
      origin: {
        inputName: "pickupName",
      },
    },
    date: {
      queryParam: {
        start: "",
        end: "",
      },
    },
    form: {
      action: "https://cars.cartrawler.com/expedia/{locale}-id/book#/vehicles",
    },
    timeValues: timeValues24HoursFormat,
    defaultShowingTime: "10:30",
    isCarTrawler: true,
    showVendorOptions: false,
    clientID: 312156,
    residenceID: "ID",
    includeGT: false,
    gtConfig: {
      location: {
        destination: {
          labelToken: "wizard.gt.propertyName.label",
        },
      },
    },
  },
  hotel: {
    useTravelAgentSearchWizardConfig: true,
    packageRatesTermsUrl: "/static/default/default/taap/contracts/hpr/ID.HPR.012021.pdf",
    navigation: {
      tabTitleToken: "wizard.properties.tab.title.label",
    },
    heading: {
      hideLobTitle: true,
      locTitleToken: "wizard.taap.hotel.tab.title.label",
    },
  },
  lx: {
    navigation: {
      tabTitleToken: "wizard.activities.tab.title.label",
    },
    location: {
      destination: {
        labelToken: "wizard.activitiesIn.thingsToDoIn.label",
      },
    },
  },
};
